import type {RubyPlayGameClientWrapperSettings} from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapperSettings';
import type {ResponseBody} from '@gongxigames/framework/integrations/rubyplay/types';
import type {IModHandler} from './IModeHandler';
import {URLParameters} from '@gongxigames/framework/core';

const FUN_MODE_NAME = 'fun';

export class FunModeHandler implements IModHandler {
    private funModeData: any;

    constructor(
        private readonly settings: RubyPlayGameClientWrapperSettings
    ) {}

    public getInitSessionRequestPayload(): Record<string, any> {
        const currency = this.getActualCurrency();
        const funModeBalance = this.settings.get('funModeBalance');
        const result: Record<string, any> = {};

        result.mode = FUN_MODE_NAME;

        if (currency) {
            result.currency = currency;
        }

        if (funModeBalance) {
            result.balance = funModeBalance;
        }

        return result;
    }

    public handleInitSessionResponse(body: ResponseBody): void {
        this.funModeData = body.funModeData;
    }

    public getActionRequestPayload(): object {
        return {funModeData: this.funModeData};
    }

    public handleActionResponse(body: ResponseBody): void {
        this.funModeData = body.funModeData;
    }

    public getOddsAcceptancePayload(): object {
        return {mode: FUN_MODE_NAME};
    }

    private getActualCurrency(): string | undefined {
        const currency = this.settings.get('currency');
        const urlParameters = new URLParameters(window.location.search.substring(1));

        if (!urlParameters.hasParameter('currency')) {
            return;
        }

        return currency;
    }

    public extendUrl(url: string): string {
        return `${url}/demo`;
    }
}